/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.15
 */
import { coattail } from '@/utils/Bezier';
let { Polyline, point: toPoint } = L;
let { _projectLatlngs, toGeoJSON } = Polyline.prototype
/**
 * 军标箭头
 */
export default Polyline.extend({
  /**
   * @param options
   */
  options: {
    fill: true,
    noClip: true
  },
  /**
   * @override
   */
  _projectLatlngs(latlngs, result, projectedBounds) {
    let temp = [];
    _projectLatlngs.call(this, latlngs, temp, projectedBounds);
    temp = temp[0].map(p => [p.x, p.y]);
    temp = coattail(temp, 0.005, this.options);
    result = result[0] = [];
    for (let i = 0, l = temp.length; i < l; i++) {
      result[i] = toPoint(temp[i][0], temp[i][1]);
      projectedBounds.extend(result[i]);
    }
  },
  /**
   * 
   */
  toGeoJSON() {
    let json = toGeoJSON.call(this);
    json.geometry.type = 'MilitaryArrow'
    return json;
  }
})


// WEBPACK FOOTER //
// ./src/marker/MilitaryArrow.js